
import { useState, useEffect } from "react";
import { CustomCanvas } from "@/types/fabric";
import { CustomPencilBrush } from "@/lib/custom-pencil-brush";
import { Tool } from "./use-canvas-setup";

export const useStudioSetup = (
  canvas: CustomCanvas | null,
  setIsCanvasEmpty: (empty: boolean) => void,
) => {
  const [rawMode, setRawMode] = useState(true);

  useEffect(() => {
    if (canvas && canvas.freeDrawingBrush instanceof CustomPencilBrush) {
      canvas.freeDrawingBrush.setRawMode(rawMode);
    }
  }, [canvas]);

  useEffect(() => {
    if (!canvas) return;

    const checkIfEmpty = () => {
      setIsCanvasEmpty(canvas.getObjects().length === 0);
    };

    canvas.on('object:added', checkIfEmpty);
    canvas.on('object:removed', checkIfEmpty);

    return () => {
      canvas.off('object:added', checkIfEmpty);
      canvas.off('object:removed', checkIfEmpty);
    };
  }, [canvas, setIsCanvasEmpty]);

  const handleRawModeChange = (enabled: boolean) => {
    if (canvas && canvas.freeDrawingBrush instanceof CustomPencilBrush) {
      canvas.freeDrawingBrush.setRawMode(enabled);
    }
    setRawMode(enabled);
  };

  return {
    rawMode,
    handleRawModeChange,
  };
};
